import { DocumentData, DocumentFieldName, FormDocument } from '@/api/types';

import { getDateWithoutTime } from '../../../helpers/dates';

export function profileDocumentDataInfoFieldsMapper(fields: Nullable<DocumentData['fields']>): FormDocument['info'] {
  return Object.entries(fields ?? {}).reduce(
    (accumulator, currentValue) => {
      const [profileFieldName, profileFieldValue] = currentValue;

      if (accumulator) {
        switch (true) {
          case profileFieldName === 'expiredDate':
            accumulator[DocumentFieldName.expirationDate] = profileFieldValue;
            break;
          case profileFieldName === 'dateIssue':
            accumulator[DocumentFieldName.date] = profileFieldValue;
            break;
          case profileFieldName === 'issue':
            accumulator[DocumentFieldName.auth_dep] = profileFieldValue;
            break;
          case profileFieldName === 'unzr':
            accumulator[DocumentFieldName.unzr] = profileFieldValue;
            break;

          case profileFieldName === 'referenceNumber':
            accumulator[DocumentFieldName.serialNumberDoc] = profileFieldValue;
            break;

          default:
            break;
        }
      }

      return accumulator;
    },
    {} as FormDocument['info'],
  );
}

export const MAX_DOCUMENTS_DEFAULT = 5;
export const todaysDate = getDateWithoutTime(new Date());
